/* =====================================================================
   RUNTIME CORRECTIONS - July 2026
   Three fixes that cannot be made in Liquid without rewriting files too
   large to edit safely through the Admin API (main-product.liquid is
   177 KB, footer.liquid is 63 KB, and the Admin code editor would not
   load). All are removable: delete this file and its <script> tag in
   layout/theme.liquid once the permanent edits below are made.
   ===================================================================== */

/* ---------------------------------------------------------------------
   FIX 1 - Double-escaped entities in accessible names

   Quantity controls announce the raw HTML entity to screen readers:
     "Decrease quantity for KDK Y56RC Ceiling Fan 56&quot; (3 Blade)"
   Every product with an inch mark in its title is affected, which is
   most of the KDK fan range.

   CAUSE: eight places pass an already-escaped value through `escape` a
   second time, so `&quot;` becomes `&amp;quot;` and renders literally:
     {{ 'products.product.quantity.decrease' | t: product: product.title | escape }}
   The `t` filter already escapes interpolated values.

   PERMANENT FIX - remove the trailing `| escape` on each:
     sections/main-product.liquid      lines 1103, 1133
     sections/main-cart-items.liquid   lines 134, 142, 147
     snippets/cart-drawer.liquid       lines 149, 157, 162
   --------------------------------------------------------------------- */

/* ---------------------------------------------------------------------
   FIX 2 - Apple Pay badge

   Payment marks are generated from shop.enabled_payment_types, which
   reports APPLE_PAY because the gateway advertises support. Apple Pay is
   NOT available in Sri Lanka - Apple's own supported-countries list omits
   it and Sri Lankan-issued cards cannot be added to Apple Wallet.
   Advertising a payment method no local customer can use is misleading at
   the exact moment trust matters.

   Payment and gateway settings are deliberately NOT touched. This is a
   display-level suppression only.

   PERMANENT FIX - disable the Apple Pay wallet in Settings > Payments, or
   replace the shop.enabled_payment_types loop with an explicit list.
   --------------------------------------------------------------------- */

/* ---------------------------------------------------------------------
   FIX 3 - Footer contact email

   The footer hardcodes info@eliteradio.com while Shopify's store record,
   all 15 Godrej product descriptions and the structured data all use
   shoponline@eliteradio.com. Publishing two addresses splits enquiries
   and contradicts what Google reads from the schema.

   PERMANENT FIX - sections/footer.liquid line 238, replace both the href
   and the link text:
     <div><a href="mailto:shoponline@eliteradio.com" style="color:inherit; text-decoration:none;">shoponline@eliteradio.com</a></div>
   --------------------------------------------------------------------- */

(function () {
  var ENTITY = /&(quot|amp|#39|apos|lt|gt|#\d+);/;
  var SUPPRESSED_WALLETS = ['apple pay'];
  var OLD_EMAIL = 'info@eliteradio.com';
  var NEW_EMAIL = 'shoponline@eliteradio.com';

  function decode(str) {
    if (!str || !ENTITY.test(str)) return null;
    var el = document.createElement('textarea');
    el.innerHTML = str;
    var out = el.value;
    return out === str ? null : out;
  }

  function fixNode(node) {
    if (!node || node.nodeType !== 1) return;

    var label = node.getAttribute && node.getAttribute('aria-label');
    if (label) {
      var fixedLabel = decode(label);
      if (fixedLabel) node.setAttribute('aria-label', fixedLabel);
    }

    var title = node.getAttribute && node.getAttribute('title');
    if (title) {
      var fixedTitle = decode(title);
      if (fixedTitle) node.setAttribute('title', fixedTitle);
    }

    /* Visually-hidden button text is the accessible name for the
       quantity plus/minus controls. Only touch leaf text nodes so no
       markup is disturbed. */
    if (!node.children.length && node.textContent) {
      var fixedText = decode(node.textContent);
      if (fixedText) node.textContent = fixedText;
    }
  }

  function stripUnavailableWallets(scope) {
    scope.querySelectorAll('svg > title').forEach(function (t) {
      var name = (t.textContent || '').trim().toLowerCase();
      if (SUPPRESSED_WALLETS.indexOf(name) === -1) return;
      var svg = t.parentNode;
      /* Remove the whole list item so no empty slot or gap is left. */
      var item = svg.closest('li, .list-payment__item, .payments_list_cart li');
      (item || svg).remove();
    });
  }

  function alignContactEmail(scope) {
    scope.querySelectorAll('a[href="mailto:' + OLD_EMAIL + '"]').forEach(function (a) {
      a.setAttribute('href', 'mailto:' + NEW_EMAIL);
      if (a.textContent.trim() === OLD_EMAIL) a.textContent = NEW_EMAIL;
    });
  }

  function sweep(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[aria-label], [title], .visually-hidden').forEach(fixNode);
    if (root && root.nodeType === 1) fixNode(root);
    stripUnavailableWallets(scope);
    alignContactEmail(scope);
  }

  function start() {
    sweep(document);

    /* Cart drawer, quantity updates and section re-renders inject fresh
       markup, so re-sweep whatever gets added. */
    if (typeof MutationObserver === 'undefined') return;
    var pending = false;
    var queue = [];
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) queue.push(n);
        });
      });
      if (pending || !queue.length) return;
      pending = true;
      requestAnimationFrame(function () {
        var batch = queue.splice(0, queue.length);
        batch.forEach(sweep);
        pending = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
